import * as React from "react";
import Box from "@mui/material/Box";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { makeStyles } from "@mui/styles";
import Modal from "@mui/material/Modal";
import { useState } from "react";
import { MobileWeb } from "./mobile/BreakPoint";
import { Theme } from "@mui/material";
import YoutubeSlider2 from "./YoutubeSlider2";
import MobileYoutubeSlider2 from "./mobile/MobileYoutubeSlider2";
import nursing2 from "../asset/bpd_youtube_thumbnail.png";

interface IVideoBox {
  className?: string;
  style?: string;
  sx?: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    // height: 229,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
    },
  },
  boxImage: {
    width: 854,
    height: 374,
    textAlign: "center",
    zIndex: 10,
    cursor: "pointer",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      height: 170,
      width: "100%",
    },
  },
  box: {
    width: 854,
    height: 374,
    textAlign: "center",
    backgroundColor: "#E0E0E0",
    "&:hover": {
      backgroundColor: "#E0E0E1",
      opacity: [0.9, 0.8, 0.7],
    },
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      height: 170,
      width: "100%",
    },
  },

  box2: {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 1000,
    height: 636,
    backgroundColor: "#fff",
    textAlign: "center",
    display: "flex",

    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "320px",
      height: "auto",
      display: "flex",
      alignItems: "center",
      justifycontent: "center",
      textAlign: "center",
    },
  },
  WebYoutube: {
    display: "flex",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      display: "none",
    },
  },
  MobYoutube: {
    display: "none",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      display: "flex",
    },
  },
  ArrowIcon: {
    width: "80px",
    height: "80px",
    position: "relative",
    top: "-220px",
    zIndex: 100,
    color: "white",
    cursor: "pointer",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      position: "relative",
      top: "-115px",
    },
  },
}));

export default function VideoBox2(props: IVideoBox) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  console.log("모달2", { open });

  return (
    <div className={classes.container}>
      <Box onClick={handleOpen} className={classes.box}>
        {/* 영상 썸네일 */}
        <img src={nursing2} className={classes.boxImage} alt="nursing2" />
        <PlayArrowIcon
          className={classes.ArrowIcon}
          sx={{
            height: "2em",
            width: "2em",
          }}
        />
      </Box>
      <Modal open={open} onClose={handleClose}>
        <Box
          className={classes.box2}
          sx={{ alignItems: "center", justifyContent: "center" }}
        >
          <div className={classes.WebYoutube}>
            <YoutubeSlider2 />
          </div>
          <div className={classes.MobYoutube}>
            <MobileYoutubeSlider2 />
          </div>
        </Box>
      </Modal>
    </div>
  );
}
